import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Input, OnDestroy, Optional, Inject } from '@angular/core';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { DomainService } from '../../domainservices/domain.service';
import { UtilService } from 'src/app/utils/util.service';
import { MappingService } from '../../../mapping/mappingservices/mapping.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { teamModel } from '../../../team/teammodels/model';
import * as moment from 'moment';
import { isString } from 'util';
import { FilterUtils } from 'primeng/utils';

@Component({
  selector: 'app-domaintable',
  templateUrl: './domaintable.component.html',
  styleUrls: ['../../../../../app.component.css']
})
export class DomaintableComponent implements OnInit, OnDestroy
{
  @Output() AddTabController = new EventEmitter();
  @Input() requiredData: any;
  @Input() tabInformation: any;
  cols: any[];   // Array for Showed Columns
  allCols: any[];  // Array for All Columns
  colFilterOptions: any[]; // Array for Each Columns including with frozen
  data: teamModel[]; // Data Storing for Table
  isFilter = false;  // for Column Filter Toggle
  isGlobalFilter = false;  // for Global Filter Input
  filterOptions: any = {};  // Data Storing for Column Unique Values
  footerValues: any = {}; // Data Storing for Column Footer
  frozenCols: any[]; // for Frized Columns
  dates: any[];   // for Dates Filter by Today, Yesterday etc
  scrollHeight: any;
  bodyObject: any = {}; // for Body Object Passing to The Server
  startDate: any;   // Store Start Date
  endDate: any;   // Store End Date
  loading: boolean;  // for Lazy Loding
  subscription: Subscription[] = [];
  fileName: any;
  tableName: any;
  teamId: any;
  isAdmin = false;
  listId: any;
  segmentId: any;
  mailingId: any;
  offerId: any;
  accountId: any;
  espConnectionId: any;
  listOptions: any[] = [];
  teamOptions: any[] = [];
  showModel: any = '';
  // getCorrectDate: number;  // Store Swaped Date
  constructor(
    private domainService: DomainService,
    private utilService: UtilService,
    private mappingService: MappingService,
    private messageService: MessageService,
    @Optional() private dialogRef: MatDialogRef<DomaintableComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public mailingData: any
  )
  {
    // Dates Array for Date Selection
    this.startDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
    this.endDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
  }

  ngOnInit()
  {
    this.scrollHeight = this.utilService.scrollableTableHeight + 'px';
    // All Columns of Table
    this.allCols = [
      { field: "isp_name_or_others", header: "Domain Name", type: false },
      { field: "portal_name", header: "Portal Name", type: false },
      { field: "account_name", header: "Account Name", type: false },
      { field: "targeted", header: "Targeted", type: true },
      { field: "sent", header: "Sent Count", type: true },
      { field: "success", header: "Success Count", type: true },
      { field: "unique_opens", header: "Opens", type: true },
      { field: "open_rate", header: "Open%", type: true },
      { field: "unique_clicks", header: "Clicks", type: true },
      { field: "click_rate", header: "CTR", type: true },
      { field: "unsubscribes", header: "Unsub", type: true },
      { field: "complaints", header: "Complaints", type: true },
      { field: "unsub_persent", header: "Unsub%", type: true },
      { field: "utr", header: "UTR", type: true },
      { field: "failed", header: "Failed", type: true },
      { field: "hard_bounces", header: "Hard Bounce", type: true },
      { field: "hard_bounces_percent", header: "Hard Bounce%", type: true },
      { field: "soft_bounces", header: "Soft Bounce", type: true },
      { field: "soft_bounces_percent", header: "Soft Bounce%", type: true }
    ];

    // Frized Columns
    this.frozenCols = [{ field: "isp_name_or_others", header: "Domain Name", type: true }];

    // All Columns for Filter Options
    this.colFilterOptions = [
      { field: "portal_name", header: "Portal Name", type: false },
      { field: "account_name", header: "Account Name", type: false },
      { field: "targeted", header: "Targeted", type: true },
      { field: "sent", header: "Sent Count", type: true },
      { field: "success", header: "Success Count", type: true },
      { field: "unique_opens", header: "Opens", type: true },
      { field: "open_rate", header: "Open%", type: true },
      { field: "unique_clicks", header: "Clicks", type: true },
      { field: "click_rate", header: "CTR", type: true },
      { field: "unsubscribes", header: "Unsub", type: true },
      { field: "complaints", header: "Complaints", type: true },
      { field: "unsub_persent", header: "Unsub%", type: true },
      { field: "utr", header: "UTR", type: true },
      { field: "failed", header: "Failed", type: true },
      { field: "hard_bounces", header: "Hard Bounce", type: true },
      { field: "hard_bounces_percent", header: "Hard Bounce%", type: true },
      { field: "soft_bounces", header: "Soft Bounce", type: true },
      { field: "soft_bounces_percent", header: "Soft Bounce%", type: true }
    ];

    // First Time Showed Columns
    this.cols = localStorage.domainTable ? JSON.parse(localStorage.domainTable) : [
      { field: "portal_name", header: "Portal Name", type: false },
      { field: "account_name", header: "Account Name", type: false },
      { field: "targeted", header: "Targeted", type: true },
      { field: "sent", header: "Sent Count", type: true },
      { field: "success", header: "Success Count", type: true },
      { field: "unique_opens", header: "Opens", type: true },
      { field: "unique_clicks", header: "Clicks", type: true },
      { field: "unsubscribes", header: "Unsub", type: true },
      { field: "complaints", header: "Complaints", type: true },
      { field: "failed", header: "Failed", type: true },
      { field: "hard_bounces", header: "Hard Bounce", type: true },
      { field: "soft_bounces", header: "Soft Bounce", type: true }
    ];

    if (!this.tabInformation)
    {
      this.tabInformation = {
        tabType: this.mailingData.mailing_name,
        tabHeader: "-" + this.mailingData.mailing_id
      };
      // let floorElements = document.getElementsByClassName("ui-table-caption");
      // for (var i in floorElements) {
      //   floorElements[i].style.height = AppConstants.FLOOR_SIZE_IN_PX + 'px';
      // }
    }
    // Setting Default Date for Data
    if (!this.mailingData)
    {
      this.accountId = this.requiredData.data.account_id || '';
      this.espConnectionId = this.requiredData.data.esp_connection_id || '';
      this.teamId = this.requiredData.data.team_id || '';
      this.listId = this.requiredData.data.list_id || '';
      this.segmentId = this.requiredData.data.segment_id || '';
      this.offerId = this.requiredData.data.offer_id || '';
      this.mailingId = this.requiredData.data.mailing_id || '';
      this.startDate = this.requiredData.date1 || moment().subtract(1, 'day').format('YYYY-MM-DD');
      this.endDate = this.requiredData.date2 || moment().subtract(1, 'day').format('YYYY-MM-DD');
      if (this.teamId === 2020)
      {
        this.isAdmin = true;
        // this.getTeamListData();
      }
      // this.getOngageListData();
    }

    this.filterData();

    FilterUtils['filterNumber'] = (value, filter): boolean =>
    {
      // 
      let lessThan = document.getElementById(filter + '_less_than') ? (<HTMLInputElement>document.getElementById(filter + '_less_than')).value : null;
      let greaterThan = document.getElementById(filter + '_greater_than') ? (<HTMLInputElement>document.getElementById(filter + '_greater_than')).value : null;

      if (value === undefined || value === null)
      {
        return false;
      }
      if ((Number(greaterThan) === undefined && Number(lessThan) === undefined) || (Number(greaterThan) === null && Number(lessThan) === null))
      {
        return value;
      }
      if (Number(greaterThan) && Number(lessThan))
      {
        return FilterUtils.gt(value, greaterThan) && FilterUtils.lt(value, lessThan);
      } else if (Number(greaterThan))
      {
        return FilterUtils.gt(value, greaterThan);
      } else if (Number(lessThan))
      {
        return FilterUtils.lt(value, lessThan);
      } else
      {
        return value;
      }
    };

    FilterUtils['filterString'] = (value, filter): boolean =>
    {

      let startString = document.getElementById(filter + '_starts_with') ? (<HTMLInputElement>document.getElementById(filter + '_starts_with')).value : null;
      let endString = document.getElementById(filter + '_ends_with') ? (<HTMLInputElement>document.getElementById(filter + '_ends_with')).value : null;

      if (value === undefined || value === null)
      {
        return false;
      }
      if ((startString === undefined && endString === undefined) || (startString === null && endString === null))
      {
        return value;
      }
      if (startString && endString)
      {
        return FilterUtils.startsWith(value, startString) && FilterUtils.endsWith(value, endString);
      } else if (startString)
      {
        return FilterUtils.startsWith(value, startString);
      } else if (endString)
      {
        return FilterUtils.endsWith(value, endString);
      } else
      {
        return value;
      }
    };
  }

  // For Showing Filter Model
  letShowModel(column: any, value: any)
  {
    return value === column ? false : true;
  }
  // For Showing Filter Model
  setShowModelValue(columnValue: any)
  {
    return this.showModel = columnValue;
  }
  // For Hiding Filter Model
  hideDialog()
  {
    return this.showModel = '';
  }

  // Filter Data Based on Date
  filterData(cols?: any, teamOrList?: any)
  {
    if (isString(cols) && teamOrList === 'list_id')
    {
      this.listId = cols;
    } else if (teamOrList === 'team_id')
    {
      this.teamId = cols;
      this.listOptions = [];
      this.listId = '';
      this.getOngageListData();
    }
    // else {
    //   this.updateStateCols(cols);
    // }
    this.fileName = "_(" + this.startDate + "-" + this.endDate + ")";
    this.tableName = "Domain_Data_" + this.fileName;
    if (this.endDate && !this.isFilter)
    {
      this.loading = true;
      // Passing Updated/Filtered Date
      if (this.mailingData)
      {
        this.bodyObject = {
          mailing_id: this.mailingData.mailing_id,
          start_date: this.startDate,
          end_date: this.startDate,
          team_id: this.mailingData.team_id,
          esp_connection_id: this.mailingData.esp_connection_id
        };
      }
      if (!this.mailingData)
      {
        this.bodyObject = {
          account_id: this.accountId || '',
          esp_connection_id: this.espConnectionId || '',
          team_id: this.teamId || '',
          list_id: this.listId || '',
          segment_id: this.segmentId || '',
          offer_id: this.offerId || '',
          mailing_id: this.mailingId || '',
          start_date: this.startDate,
          end_date: this.endDate
        };
      }
      // Getting Data From Server
      if (this.bodyObject && !this.isFilter)
      {
        this.subscription.push(this.domainService.getDomainData(this.bodyObject).subscribe(responseData =>
        {

          if (responseData['error'] === 'Expired token')
          {
            this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Loged out', detail: 'Session expired, please login again!!!' });
            return this.utilService.logedOut();
          }
          if (responseData['code'])
          {
            this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Warning', detail: 'Something went wrong! Server not responding!' });
            return null;
          }
          this.data = responseData as teamModel[];
          console.log(this.data);
          this.loading = false;
          this.footerValues = { undefined };
          if (this.data.length !== 0)
          {
            this.getFooterData(this.data);
            this.filterOptions = this.utilService.getRequiredOptions(
              this.data,
              this.data[0]
            );
          } else
          {
            this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Warning', detail: 'Data not found in the given parameters' });
          }
        }, err =>
        {
          if (err)
          {
            this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Warning', detail: 'Something went wrong! Server not responding!' });
            this.loading = false;
            return null;
          }
        }));
      }

    }
  }

  // Update Filter Options
  updateFilterOptions(tableData, colName)
  {
    if (tableData !== null)
    {
      this.getFooterData(tableData);
      this.filterOptions = this.utilService.getRequiredOptions(
        tableData,
        tableData[0]
      );
      this.filterOptions[colName] = this.utilService.getUniqueValuesObjectFromArray(this.data, colName);
    }
  }


  // Update Footer Values
  getFooterData(tableData)
  {
    this.footerValues = this.utilService.getRequiredFooterData(tableData);
  }


  // Add New Tab in Tab Array
  addNewTab(type, header, startDate, endDate, data)
  {
    this.AddTabController.emit({ type, header, startDate, endDate, data });
  }

  // Getting Dates from Dates Component
  getDates(datesObj)
  {
    if (datesObj)
    {
      this.startDate = datesObj.start_date;
      this.endDate = datesObj.end_date;
      this.filterOptions = [];
      this.filterData();
    }

  }

  // Columns State Save
  saveColumnState(dt: any)
  {
    localStorage.domainTable = JSON.stringify(dt.columns);
  }

  // Adding Column For Exporting in Csv
  exportData(dt)
  {
    dt.columns.splice(0, 0, this.frozenCols[0]);
    dt.exportCSV();
    return dt.columns.splice(0, 1);
  }

  // For Getting Team Array
  getTeamListData()
  {

    this.subscription.push(this.mappingService.getTeamList().subscribe((listArray: any[]) =>
    {
      if (listArray !== null)
      {
        this.teamOptions.push({ label: 'All Teams', value: '2020' });
        listArray.map(keyValue => { this.teamOptions.push({ label: keyValue.team_name, value: keyValue.id }) });
      }
    }));
  }

  // For Getting List Array
  getOngageListData()
  {
    const body = {
      team_id: this.teamId
    };
    this.subscription.push(this.mappingService.getListOrderingDetails(body).subscribe((listArray: any[]) =>
    {
      if (listArray !== null)
      {
        this.listOptions.push({ label: 'All List', value: '' });
        listArray.map(keyValue => { this.listOptions.push({ label: keyValue.list_name, value: keyValue.list_id }) });
      }
    }));
  }

  // For Closing Domain Report Window
  hideDomainWindow()
  {
    this.dialogRef.close();
  }

  // For getting string length(Tooltip)
  showTooltip(text: any)
  {
    return text && (String(text).length > 9) ? text : '';
  }

  // Destroy all subscriptons
  ngOnDestroy(): void
  {
    this.subscription.forEach(e => e.unsubscribe());
  }

}
